const common = {
  "site.name": "韩漫漫画网站",
  "site.slogan": "免费韩漫，漫画大全，在线漫画，好看的韩国漫画",
  "nav.home": "首页",
  "nav.category": "分类",
  "nav.about": "关于我们",
  "nav.search": "搜索漫画...",
  "home.hero.title": "探索韩国漫画的无限世界",
  "home.hero.subtitle": "海量免费韩漫资源，每日更新，随时随地畅享阅读",
  "home.hero.cta": "开始阅读",
  "home.hot.title": "热门推荐",
  "home.hot.subtitle": "本周最受欢迎的韩漫作品",
  "home.latest.title": "最新更新",
  "home.latest.subtitle": "刚刚更新的精彩漫画",
  "home.category.title": "分类浏览",
  "home.category.subtitle": "探索你感兴趣的漫画类型",
  "home.ranking.title": "人气排行",
  "home.ranking.subtitle": "全站阅读量最高的漫画",
  "home.viewAll": "查看全部",
  "home.readNow": "立即阅读",
  "category.all": "全部",
  "category.romance": "恋爱",
  "category.fantasy": "奇幻",
  "category.action": "动作",
  "category.thriller": "悬疑",
  "category.comedy": "搞笑",
  "category.drama": "剧情",
  "category.bl": "耽美",
  "comic.chapters": "章节",
  "comic.status": "状态",
  "comic.author": "作者",
  "comic.rating": "评分",
  "comic.views": "阅读量",
  "comic.updated": "更新时间",
  "comic.serializing": "连载中",
  "comic.completed": "已完结",
  "comic.related": "相关推荐",
  "comic.description": "作品简介",
  "comic.chapterList": "章节列表",
  "comic.startReading": "开始阅读",
  "about.title": "关于我们",
  "about.brand": "品牌介绍",
  "about.reputation": "口碑展示",
  "about.contact": "联系我们",
  "footer.copyright": "© 2026 韩漫漫画网站 版权所有",
  "footer.privacy": "隐私政策",
  "footer.terms": "服务条款",
  "footer.contact": "联系我们",
  "breadcrumb.home": "首页",
  "breadcrumb.category": "分类",
  "breadcrumb.about": "关于我们",
  "loading": "加载中...",
  "error": "加载失败，请重试",
  "retry": "重试",
  "backToTop": "回到顶部",
};

export default common;